import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const FramtidensElmarknad = lazy(() => import("@/pages/elmarknaden/FramtidensElmarknad"));

export const Route = createFileRoute("/elmarknaden/framtiden")({
  head: () => seoHead("/elmarknaden/framtiden", { description: "Elanvändningen väntas mer än fördubblas till 2045. Så förändras marknaden – och vad det betyder för dig som elkund." }),
  component: () => <FramtidensElmarknad />,
});
